import { useState, useRef, useEffect } from "react";
import { TextField, IconButton, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../../i18n/useTranslation";

export default function SearchInput() {
    const [value, setValue] = useState<string>("");
    const [width, setWidth] = useState<number>(200);
    const inputRef = useRef<HTMLInputElement>(null);
    const spanRef = useRef<HTMLSpanElement>(null);
    const navigate = useNavigate();
    const { t } = useTranslation('translation');
    
    const handleSearch = () => {
        if (value.trim()) {
            navigate(`/webshop/search/${encodeURIComponent(value)}`);
        }
    };


    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (!inputRef.current) {
            return;
        }

        const input = inputRef.current;
        const start = input.selectionStart || 0;
        const end = input.selectionEnd || 0;

        if (e.key === " ") {
            e.preventDefault();
            const newValue = value.substring(0, start) + " " + value.substring(end);
            setValue(newValue);

            requestAnimationFrame(() => {
                input.selectionStart = input.selectionEnd = start + 1;
            });
        } else if (e.key === "Enter") {
            e.preventDefault();
            handleSearch();
        }
    };

    useEffect(() => {
        if (spanRef.current) {
            const newWidth = spanRef.current.offsetWidth * 1.1;
            setWidth(Math.max(200, Math.min(newWidth, 500)));
        }
    }, [value]);

    return (
        <div style={{ display: "inline-block", position: "relative" }}>
            <TextField
                size="small"
                value={value}
                inputRef={inputRef}
                onChange={(e) => setValue(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder={t('PRODUCT_NAME_OR_CODE')}
                sx={{ width }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                        <IconButton size="small" onClick={handleSearch}>
                            <SearchIcon fontSize="small" />
                        </IconButton>
                        </InputAdornment>
                    ),
                    sx: {
                        "& .MuiOutlinedInput-input::placeholder": {
                            fontSize: "12px",

                        }
                    }
                }}
            />

            <span
                ref={spanRef}
                style={{
                position: "absolute",
                visibility: "hidden",
                whiteSpace: "pre",
                fontSize: "0.8125rem",
                fontFamily: "Roboto, sans-serif",
                padding: "8.5px 14px",
                pointerEvents: "none"
                }}
            >
                {value || t('PRODUCT_NAME_OR_CODE')}
            </span>
        </div>
    );
}